import axios from "axios";
import { documentUrl, inventoryUrl } from "../../Config/Url";
import { documentTypes } from "../../Config/DocumentTypes";

const { inventory } = documentTypes;

export const inventoryService = {
  documentSearch,
  documentDelete,
  documentLock,
  documentCreate,
  documentUpdate,
  getDocumentById,
  documentDetails,
  inventoryDocuments,
};

async function documentSearch(
  tenantId,
  searchText,
  pageIndex,
  pageSize,
  sortName,
  isAsc,
  storeId,
  dateFrom,
  dateTo
) {
  return axios
    .put(`${inventoryUrl}/search`, {
      tenantId,
      searchText,
      pageIndex,
      pageSize,
      sortName,
      isAsc,
      documentTypeId: inventory,
      storeId,
      dateFrom,
      dateTo,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function documentDelete(documentGuid) {
  return axios
    .delete(`${inventoryUrl}/${documentGuid}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function documentLock(documentGuid) {
  return axios
    .patch(`${inventoryUrl}/${documentGuid}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function documentCreate(
  storeId,
  documentDate,
  documentYear,
  note,
  products
) {
  let items = products.map((item) => ({
    productGuid: item.productGuid,
    bookQuantity: Number(item.bookQuantity),
    realQuantity: Number(item.realQuantity),
    price: item.price,
  }));

  return axios
    .post(inventoryUrl, {
      documentTypeId: inventory,
      storeId,
      documentDate,
      documentYear,
      note,
      items,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function documentUpdate(
  documentGuid,
  storeId,
  documentDate,
  documentYear,
  note,
  products
) {
  let items = products.map((item) => ({
    inventoryDetailGuid: item.inventoryDetailGuid,
    productGuid: item.productGuid,
    bookQuantity: Number(item.bookQuantity),
    realQuantity: Number(item.realQuantity),
    price: item.price,
    isActive: Boolean(item.isActive),
  }));

  return axios
    .put(`${inventoryUrl}/${documentGuid}`, {
      storeId,
      documentDate,
      documentYear,
      note,
      items,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function documentDetails(documentGuid) {
  return axios
    .get(`${inventoryUrl}/${documentGuid}/details`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function getDocumentById(documentGuid) {
  return axios
    .get(`${inventoryUrl}/${documentGuid}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function inventoryDocuments(inventoryDocumentGuid) {
  return axios
    .get(`${documentUrl}/${inventoryDocumentGuid}/inventory`)
    .then((res) => res)
    .catch((err) => err.response);
}
